import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const Edit = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Path
      d="m20.86 4.65-1.82-1.82a1.56 1.56 0 0 0-1.11-.46c-.4 0-.8.15-1.11.46l-2.14 2.14 4.04 4.04 2.14-2.14c.61-.61.61-1.6 0-2.21v-.01ZM3.7 19.87c-.1.36.24.69.59.58l4.68-1.54-3.87-3.9-1.39 4.87-.01-.01ZM14.09 5.69l-8.39 8.6 3.91 4.01L18 9.7l-3.91-4.01Zm-4.74 9.7-.94-.94 5.84-5.84.94.94-5.84 5.84Z"
      fill={color}
    />
  </Svg>
)

export default Edit
